import { render, staticRenderFns } from "./top_header.vue?vue&type=template&id=45a9d56a"
import script from "./top_header.vue?vue&type=script&lang=js"
export * from "./top_header.vue?vue&type=script&lang=js"
import style0 from "./top_header.vue?vue&type=style&index=0&id=45a9d56a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports